import { SignUp } from '@clerk/nextjs'
import { NextSeo } from 'next-seo'

export default function SignOpPage() {
  return (
    <>
      <NextSeo title="v0 report - sign up" />
      <div className="w-full lg:grid lg:grid-cols-12">
        {/* Desktop */}
        <div className="hidden lg:block bg-zinc-900 p-20 h-screen text-zinc-50 col-span-0 md:col-span-5">
          <div className="flex items-center w-fit">
            <h1 className="ml-4 text-3xl font-semibold">Sign in</h1>
          </div>
          <div className="h-5/6"></div>
          {/* <div className="">
            <p className="mt-auto align-bottom text-lg font-medium ">
              "Opinly was a game-changer for our Software, turning the hard work of analyzing
              competitors and market trends into clear, actionable insights, saving us countless
              hours."
            </p>
            <p className="mt-3 text-sm">David Lee</p>
          </div> */}
        </div>
        <div className="h-screen border  hidden lg:block md:block flex justify-center items-center col-span-7 my-auto">
          <div className="my-auto mx-auto grid w-[350px] gap-6 flex items-center">
            <div className="h-screen flex items-center ">
              <SignUp path="/auth/signup" />
            </div>
          </div>
        </div>

        {/* Mobile */}
        <div className="md:hidden block flex justify-center items-center h-screen">
          <SignUp path="/auth/signup" />
        </div>
      </div>
    </>
  )
}
